<h3>{{ 'common.labels.dealers' | transloco }}</h3>
<!-- Dealers -->
@if (uiConfiguration?.hasDealers) {
  <div class="flex-container no-margin">
    <lib-parties-list
      partyTypeTitle="Dealer"
      [order]="order"
      [observableParties$]="parties$"
      [errors$]="observableErrors$"
      class="flex-item"
      [isEditable]="isEditable"
      [uiConfiguration]="uiConfiguration!.debtorsConfiguration!"
      [businessPartyType]="businessDealer"
      [individualPartyType]="individualDealer"
      [defaultPartyType]="businessDealer"
      [expandedParty]="newParty"
      (partyAddedEvent)="handlePartyAddedEvent($event)"
      (partyRemovedEvent)="handlePartyRemovedEvent($event)"
      (partyUpdatedEvent)="handlePartySavedEvent($event)"
      (partyCopiedEvent)="handlePartyCopiedEvent($event)"
      (partyFormValueChangedEvent)="handlePartyFormValueChangedEvent($event)">
    </lib-parties-list>
  </div>
}